export default "__VITE_ASSET__BTlL82cz__"